import React, { FC } from 'react';
import { TerritoryExploreFilter } from '../../components/TerritoryFilter/TerritoryExploreFilter';
import { WriteInTerritoryContainer } from '../../components/WriteInTerritory/WriteInTerritoryContainer';
import { TerritoryVersionType } from './TerritoryPageLayout';

type TTerritoryPageExploreFilterLayoutProps = {
  territoryId: string;
  territorySlug: string;
  territoryVersion: TerritoryVersionType;
  territoryPageRef: React.RefObject<HTMLDivElement>;
};

export const TerritoryPageExploreFilterLayout: FC<TTerritoryPageExploreFilterLayoutProps> = ({
  territoryId,
  territorySlug,
  territoryVersion,
  territoryPageRef,
}) => (
  <div className=" flex mt-8 items-center justify-between">
    <div className="overflow-hidden">
      <TerritoryExploreFilter />
    </div>
    <div className="ml-3">
      <WriteInTerritoryContainer
        territoryId={territoryId}
        territorySlug={territorySlug}
        territoryVersion={territoryVersion}
        territoryPageRef={territoryPageRef}
      />
    </div>
  </div>
);
